import { ytVueGlobalStore } from "@/services/yt-vue-global-store";
const changeMode = ytVueGlobalStore.instantGet('changeMode');

export default {
  namespaced: true,
  state: {
    ...changeMode,
  },
};
